export const handleRegisterError = (error: any) => {
  const errorMessage =
    error.response?.data?.error ||
    'An error occurred during the registration process.';
  throw new Error(errorMessage);
};
